import {
    formatarHoras,
    hoursToMinutes as min,
    minutesToHours,
} from '@acme/common'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useImplantacaoOutletContext } from 'pages/Implantacao'
import { CreateImplantacaoSchema, SaldoHoras, saldoHoras } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'
import FormImplantacao from 'templates/ManutencaoDoPonto/ImplantacaoBancoHoras/form/FormImplantacao'

const schema = CreateImplantacaoSchema.partial({
    faltasIntegrais: true,
    faltasParciais: true,
})

export default function AdicionarImplantacao() {
    const { competencia } = useImplantacaoOutletContext()
    const { mutateAsync, isLoading } = saldoHoras.mutations.useCreate({
        invalidateQuery: true,
        onSuccess: () => {
            toast.success('Implantação adicionada com sucesso!')
        },
        onError: err => {
            toast.error(err.message)
        },
    })
    const empresa = useStore(state => state.company)
    const funcionarioId = useStore(state => state.employeeId)

    if (!empresa) return null

    const handleSubmit = (values: SaldoHoras) => {
        const cloned = structuredClone(values.porcentagemHorasExtras)
        Object.entries(cloned || {}).forEach(
            ([key, value]: [string, string]) => {
                if (value === '000:00') delete (cloned as any)[key]
            },
        )

        const totalPorcentagens = (Object.values(cloned) as string[]).reduce(
            (acc: number, curr: string) => {
                return acc + min(curr)
            },
            0,
        )

        return mutateAsync({
            competencia,
            empresaId: empresa.id,
            funcionarioId,
            faltas: formatarHoras(values.faltas, 3),
            horasExtras: minutesToHours(totalPorcentagens),
            porcentagemHorasExtras: JSON.stringify(cloned),
            faltasIntegrais: '00:00',
            faltasParciais: formatarHoras(values.faltas, 2),
            faltasInjustificadas: '00:00',
            faltasJustificadas: '00:00',
            implantacao: 'S',
        })
    }

    return (
        <Dialog.Root
            height="auto"
            loading={isLoading}
            onSubmit={handleSubmit}
            schema={schema}
            defaultValues={{
                competencia: empresa?.competenciaAtual,
                faltas: '000:00',
                horasExtras: '000:00',
                faltasInjustificadas: '00:00',
                faltasJustificadas: '00:00',
            }}
            open={hasPermission(['create', 'ImplantaçãoDoBancoDeHoras'])}
        >
            <Dialog.Title>Implantação do banco de horas</Dialog.Title>
            <Dialog.Content dividers>
                <FormImplantacao key={funcionarioId} />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
